import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { tokens } from "../../../../../theme";
import { DESIGN_OPTIONS } from "../../types/email-templates";
import { EmailTemplateStepProps } from "../../types/types";

const DesignStep: React.FC<EmailTemplateStepProps> = ({
  templateData,
  setTemplateData,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const selectDesign = (id: string) => {
    setTemplateData((prev) => ({ ...prev, design_id: id }));
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: colors.primary[700] }}
        >
          Design
        </Typography>
        <Typography variant="body2" sx={{ color: colors.primary[300] }}>
          Select a design for the email
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2.5,
        }}
      >
        {DESIGN_OPTIONS.map((design) => {
          const isSelected = templateData.design_id === design.value;
          return (
            <Box
              key={design.value}
              onClick={() => selectDesign(design.value)}
              sx={{
                position: "relative",
                aspectRatio: "1 / 1",
                borderRadius: "16px",
                bgcolor: colors.primary[800],
                border: `2px solid ${isSelected ? colors.primary[400] : "transparent"}`,
                cursor: "pointer",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                p: 1.5,
                transition: "transform 0.15s, border-color 0.15s",
                "&:hover": { transform: "translateY(-2px)" },
              }}
            >
              {isSelected && (
                <CheckCircleIcon
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    fontSize: 20,
                    color: colors.primary[400],
                    bgcolor: "#fff",
                    borderRadius: "50%",
                  }}
                />
              )}
              <Typography
                variant="caption"
                sx={{ color: colors.primary[300], fontWeight: 500 }}
              >
                {design.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default DesignStep;
